<template>
  <div :class="classes">
      <pt-page-title title="商品分组" >
          <el-button slot="before-left" type="primary" @click="created_group">新建商品分组</el-button>
      </pt-page-title>
      <group-table :tableLabels="tableLabels" :pageSize="pageSize" ref="table">
          <el-table-column label="操作">
              <template slot-scope="scope">
                  <!-- <i class="iconfont icon-xiangqing" @click="groupDetail(scope.row)"></i> -->
                  <i class="iconfont icon-dingdanchuangjian" @click="editGroup(scope.row)"></i>
                  <i class="iconfont icon-shanchu" v-if="isHasDelete(scope.row)" @click="deleteGroup(scope.row)"></i>
              </template>
          </el-table-column>
      </group-table>
  </div>
</template>

<script>
// 组件class前缀
import groupTable from './pt-group-table/withData.vue'
import { tableLabels } from './group-options.js'
const prefixCls = 'pt-goods-group'

export default {
  name: 'pt-goods-group',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    groupTable
  },
  data () {
    return {
      tableLabels: tableLabels,
      pageSize: 10
    }
  },
  methods: { // 是否允许删除分组
    isHasDelete (row) {
      return !row.system
    },
    optionSuccess () {
      let page = this.$refs.table.page
      this.$refs.table.groupList(page)
    },
    created_group () {
      this.$router.push('/goods-group/group-form/false/0')
    },
    editGroup (val) {
      this.$router.push('/goods-group/group-form/true/' + val.id)
    },
    groupDetail (val) {
      this.$router.push('/goods-group/group-form/true/' + val.id + '?type=detail')
    },
    deleteGroup (val) {
      this.$confirm('您是否确定删除该分组？分组删除后，该分组下如有商品，商品将会自动被移至“其他”分组。', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('deleteGroup', val)
      }).catch(_ => {

      })
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
</style>
<style lang="less">

.pt-goods-group{
i{
    margin-right: 10px;
}
}
</style>
